<template>
  <div class="bg-white border-b border-slate-200">
    <div class="px-6 py-4 flex items-center gap-3">
      <!-- Icon -->
      <div
        class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 shadow-sm"
        :class="iconBgClass"
      >
        <v-icon :color="iconColorHex" size="20">{{ icon }}</v-icon>
      </div>

      <!-- Title + subtitle（flex-1 min-w-0 撐開並允許內部 truncate；確保 actions 靠右）-->
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2 flex-wrap">
          <h1 class="text-base font-bold text-slate-800 leading-tight">
            {{ title }}
          </h1>
          <span
            v-if="badge"
            class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold"
            :class="badgeClass"
          >
            {{ badge }}
          </span>
        </div>
        <p v-if="subtitle" class="text-[11px] text-slate-500 mt-0.5 truncate">
          {{ subtitle }}
        </p>
      </div>

      <!-- Stats -->
      <div
        v-if="stats && stats.length > 0"
        class="hidden lg:flex items-center gap-2 shrink-0"
      >
        <div
          v-for="(s, i) in stats"
          :key="i"
          class="flex items-center gap-2 px-2.5 py-1 rounded-lg bg-slate-50 border border-slate-200"
        >
          <v-icon v-if="s.icon" size="14" :color="s.iconColor || '#64748b'">
            {{ s.icon }}
          </v-icon>
          <div class="flex flex-col justify-center leading-none gap-1">
            <div class="text-[10px] text-slate-500 uppercase tracking-wide">{{ s.label }}</div>
            <div class="text-sm font-bold text-slate-800 tabular-nums">{{ s.value }}</div>
          </div>
        </div>
      </div>

      <!-- Slot: 右側 actions（儲存 / 重設等）-->
      <div class="shrink-0 flex items-center gap-1.5 ml-1">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
const VARIANT_MAP = {
  indigo: { bg: 'bg-indigo-100', hex: '#4f46e5', badge: 'bg-indigo-50 text-indigo-700' },
  teal: { bg: 'bg-teal-100', hex: '#0d9488', badge: 'bg-teal-50 text-teal-700' },
  violet: { bg: 'bg-violet-100', hex: '#7c3aed', badge: 'bg-violet-50 text-violet-700' },
  emerald: { bg: 'bg-emerald-100', hex: '#059669', badge: 'bg-emerald-50 text-emerald-700' },
  amber: { bg: 'bg-amber-100', hex: '#d97706', badge: 'bg-amber-50 text-amber-700' }
}

export default {
  name: 'PermissionPageHeader',
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    badge: { type: String, default: '' },
    variant: {
      type: String,
      default: 'indigo',
      validator: v => Object.keys(VARIANT_MAP).includes(v)
    },
    // stats: [{ label, value, icon?, iconColor? }]
    stats: { type: Array, default: () => [] }
  },
  computed: {
    iconBgClass () {
      return VARIANT_MAP[this.variant].bg
    },
    iconColorHex () {
      return VARIANT_MAP[this.variant].hex
    },
    badgeClass () {
      return VARIANT_MAP[this.variant].badge
    }
  }
}
</script>
